import { Logger } from '@mntn-dev/logger'

export const logger = Logger('files-adapter-client')
